import classNames from 'classnames';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'wicg-inert';
import Button from 'atoms/Button/Button';
import PortalBackdrop from 'atoms/PortalBackdrop/PortalBackdrop';
import { usePrevious } from 'hooks/usePrevious';
import CloseSvg from 'images/v5/icons/x-close.svg';
import { activateSidebar, closeSidebar, removeSidebar, selectSidebarByName, } from 'store/layoutSlice';
import { getLayerZIndex } from 'utils/zIndexLayers';
import styles from './Sidebar.module.scss';
function Sidebar(props) {
    const { name, header, headerAside, children, onClose } = props;
    const dispatch = useDispatch();
    const sidebar = useSelector(selectSidebarByName(name));
    const { opened, active, layer } = sidebar || {};
    const zIndex = getLayerZIndex(layer);
    const prevActive = usePrevious(active);
    const contentClasses = classNames(styles.content, {
        [styles.contentActive]: active,
    });
    useEffect(() => {
        if (opened) {
            setTimeout(() => {
                dispatch(activateSidebar({ name }));
            }, 10);
        }
    }, [dispatch, opened, name]);
    useEffect(() => {
        if (prevActive && !active) {
            setTimeout(() => {
                dispatch(removeSidebar({ name }));
            }, 350);
        }
    }, [dispatch, active, prevActive, name]);
    const handleSidebarClose = useCallback(() => {
        dispatch(closeSidebar({ name }));
        if (onClose) {
            onClose();
        }
    }, [dispatch, onClose, name]);
    return (React.createElement(PortalBackdrop, { opened: opened, active: active, locked: true, zIndex: zIndex, onClose: handleSidebarClose },
        React.createElement("div", { className: contentClasses },
            React.createElement("header", { className: styles.header },
                React.createElement("div", null, header && header),
                React.createElement("aside", null,
                    headerAside,
                    React.createElement(Button, { size: "s", theme: "ghost", shape: "rounded", leftIcon: React.createElement(CloseSvg, null), onClick: handleSidebarClose, testId: "sidebar-close" }))),
            React.createElement("main", { className: styles.main }, children))));
}
export default Sidebar;
